<template>
  <div>
    <modal size="large" v-if="visible" @close-modal="closeModal">
      <div slot="header">
        Resumo da compra
      </div>

      <div slot="content">
        <h5>Detalhes da compra</h5>
        <p>Valor da recarga: R$ {{ (quantidadeCreditos).toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</p>
        <div v-if="bonus > 0">
          <p style="color: green">Bônus: + R$ {{ bonus.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2}) }}</p>
        </div>
        <p>
          Forma de pagamento: {{ formaPagamentoFromEnum(form.formaPagamento) }}
        </p>

        <p v-if="validadeCreditos">
          Validade dos créditos: {{ validadeCreditos }}.
          <br>
          <small>Basta que seja realizada uma nova compra para que a validade seja renovada.<br>
            Caso os créditos vençam, eles ficarão bloqueados até uma próxima compra.
          </small>
        </p>
        <a class="btn buy-credits-button" @click="comprarCreditos" :disabled="buying">Confirmar</a>
      </div>

      <div slot="footer">
      </div>

    </modal>
  </div>
</template>

<script>
  import masker from 'vue-the-mask/src/masker.js';
  import tokens from 'vue-the-mask/src/tokens';

  export default {
    props: [
      'form',
      'bonus',
      'valorPlano',
      'visible',
      'buying',
      'quantidadeCreditos',
      'pagamentoAntigo',
      'validadeCreditos'
    ],
    methods: {
      closeModal() {
        this.$emit('closeModal');
      },

      comprarCreditos() {
        this.$emit('comprarCreditos');
      },
      mask(value, mask) {
        return masker(value, mask, true, tokens);
      },
      formaPagamentoFromEnum($formaPagamento){
        switch ($formaPagamento) {
          case 'CARTAO_CREDITO':
            return 'Cartão de Crédito';
          case 'BOLETO':
            return 'Boleto';
          case 'PIX':
            return 'PIX';
        }
      }
    },
    computed:{
      desconto(){
        return this.quantidadeCreditos - this.valorPlano;
      }
    }
  }
</script>

<style lang="stylus">
p
  margin-bottom 1rem
</style>
